
import React from "react";
import { Dumbbell } from "lucide-react";
import BeginnerTierData from "./tier-specific/BeginnerTierData";
import IntermediateTierData from "./tier-specific/IntermediateTierData";
import AdvancedTierData from "./tier-specific/AdvancedTierData";
import AthleteTierData from "./tier-specific/AthleteTierData";
import GenericTierData from "./tier-specific/GenericTierData";

interface TierSpecificSectionProps {
  tier: string;
  tierData: any;
  aiContext?: any;
}

export default function TierSpecificSection({ tier, tierData, aiContext }: TierSpecificSectionProps) {
  const renderTierData = () => {
    if (!tierData) return <GenericTierData tierData={tierData} />;
    
    switch (tier) {
      case "Beginner":
        return <BeginnerTierData tierData={tierData} />;
      case "Intermediate":
        return <IntermediateTierData tierData={tierData} />;
      case "Advanced":
        return <AdvancedTierData tierData={tierData} />;
      case "Athlete":
        return <AthleteTierData tierData={tierData} />;
      default:
        return <GenericTierData tierData={tierData} />;
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white/90 flex items-center gap-2">
        <Dumbbell className="h-5 w-5" />
        {tier || "Unknown"} Tier Information
      </h3>
      <div className="bg-white/5 rounded-lg p-4 border border-white/10 max-h-[400px] overflow-y-auto">
        {renderTierData()}
      </div>
    </div>
  );
}
